import {Injectable } from '@angular/core';
import {MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition, MatSnackBarConfig} from '@angular/material/snack-bar';
import {NotificationComponent} from './notification.component';

@Injectable({
    providedIn: 'root'
})

export class NotificationService {
    message = 'An error Occured';
    action = false;
    setAutoHide = true;
    autoHide = 5000;
    horizontalPos:MatSnackBarHorizontalPosition = 'center';
    verticalPos: MatSnackBarVerticalPosition = 'bottom';

    constructor(public snackBar: MatSnackBar) {}

    showSuccess(message:string, config?:MatSnackBarConfig):void {
        config = config || new MatSnackBarConfig();
        config.verticalPosition = this.verticalPos;
        config.horizontalPosition = this.horizontalPos;
        config.duration = this.setAutoHide ? this.autoHide : 0;
        config.panelClass = ['notification-success'];
        config.data = {
            message,
            image: './assets/Alert-Success.svg'
        };

        this.snackBar.openFromComponent(NotificationComponent, {
            ...config
        });
    }

    showError(message:string, config?:MatSnackBarConfig):void {
        config = config || new MatSnackBarConfig();
        config.verticalPosition = this.verticalPos;
        config.horizontalPosition = this.horizontalPos;
        config.duration = this.setAutoHide ? this.autoHide : 0;
        config.panelClass = ['notification-error'];
        config.data = {
            message,
            image: './assets/Alert.svg'
        };

        this.snackBar.openFromComponent(NotificationComponent, {
            ...config
        });
    }
}